module.exports = __webpack_public_path__ + "img/DCR.c8af767e.svg";